import { useState } from "react";
import PropTypes from "prop-types";
import { Avatar, Box } from "@mui/material";

function RotatingCard({ children }) {
  const [rotate, setRotate] = useState(false);

  const rotate0 = () => setRotate(false);
  const rotate360 = () => setRotate(true);

  return (
    <Box
      sx={{ perspective: "50rem" }}
      onMouseEnter={rotate360}
      onMouseLeave={rotate0}
    >
      <Avatar
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          position: "relative",
          transform: rotate ? "rotateY(360deg)" : "rotateY(0)",
          transformStyle: "preserve-3d",
          transition: "all 0.8s cubic-bezier(0.34, 1.45, 0.7, 1)",
        }}
      >
        {children}
      </Avatar>
    </Box>
  );
}

// Typechecking props for the RotatingCard
RotatingCard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RotatingCard;
